<template>
  <b-card
    header="RETARD"
    header-bg-variant="info"
    header-text-variant="white"
    border-variant="info"
    align="center">
    <b-card-text @click="goTo('/andon/'+item.andon.kanban_id)">
      <b-badge pill variant="danger" v-if="item.andon.base.severity == 'high'">CRITIQUE<br/></b-badge><br/>
      <b>{{displayRef(item.andon.kanban_id)}}</b> - <small>{{item.andon.kanban_card.card_id}}</small> - {{item.andon.kanban_card.kanban_reference.reference == undefined ? "--" : item.andon.kanban_card.kanban_reference.reference.supermarket_emplacement}}
      <b-badge variant="primary">Carte N°{{item.andon.kanban_card.card_index}}</b-badge><br/>
      <b-badge variant="dark">{{stepList[item.andon.last_scan.workstation.name]['display']}}</b-badge><br/>
      depuis
      <b-badge variant="info">{{displayDate(item.andon.last_scan.created_at)}}</b-badge>
      <b-badge pill variant="secondary">{{estimated_days}} J</b-badge>
      <b-badge pill variant="danger">+{{how_much_added_time}} J</b-badge>
      <b-badge pill variant="secondary">+{{item.andon.threshold}}%</b-badge><br/>

      Prévu le <b-badge variant="info">{{displayDate(item.andon.next_step_estimated_at)}}</b-badge>
      <!-- <b-badge pill variant="secondary">{{estimated_days}} J</b-badge> -->
      <br />

    </b-card-text>
    <b-button v-if="isUserAdmin()" size="sm" variant="danger" @click="stopCardAndon()"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
    <b-button v-if="isUserAdmin()" size="sm" variant="danger" @click="deleteRef()">SUPER DELETE <i class="fa fa-trash" aria-hidden="true"></i></b-button>
  </b-card>
</template>
<script>

import server from '../../api/server.vue'
import {Steps} from '../../core/services/steps.js'

export default {
  name: 'UnseenCard',
  props: ['item'],
  data() {
    return {
      stepList: Steps,
      estimated_days: 0,
      delay_since_last_scan: 0,
      how_much_added_time: 0

    };
  },
  methods: {
    stopCardAndon () {
      server.stopSpecificAndon(this.item.andon.base_id).then(() => {
        this.$emit('andon-stopped')
      })
    },
    getIsAdmin() {
      return window.localStorage.getItem('isAdmin') === 'ADMIN'
    },
    displayRef(reference) {
      return this.chunk(reference, 3)
    },
    deleteRef () {
      server.deleteReferenceFromAndonKanban(this.item.andon.kanban_card.kanban_reference.reference.code).then(() => {
        server.stopSpecificAndon(this.item.andon.base_id).then(() => {
            this.$emit('andon-stopped')
        })
      })
    },
  },
  mounted: function() {
    this.estimated_days = (this.item.delay_estimated_next_scan / 3600 / 24).toFixed(1)
    this.delay_since_last_scan = (this.item.delay_since_last_scan / 3600 / 24).toFixed(1)
    this.how_much_added_time = ((this.item.delay_since_last_scan - this.item.delay_estimated_next_scan) / 3600 / 24).toFixed(1)
  }
};
</script>

<style type="text/css">

</style>


// WEBPACK FOOTER //
// src/components/andon/UnseenCard.vue